import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

const LOGO = "https://customer-assets.emergentagent.com/job_nexors-build/artifacts/8in622w1_remove.photos-removed-background.png";

export default function NotFoundPage() {
  const { lang } = useLang();
  const tr = t[lang];

  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center relative"
      style={{ backgroundColor: '#0A1A1A' }}
    >
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'radial-gradient(circle at 50% 40%, rgba(79,142,247,0.4) 0%, transparent 50%), radial-gradient(circle at 60% 60%, rgba(155,89,245,0.3) 0%, transparent 40%)',
        }}
      />
      <div className="relative text-center section-container">
        <img
          src={LOGO}
          alt="Exevori"
          className="h-16 w-16 rounded-xl mx-auto mb-8 opacity-60"
        />
        <div className="font-sora font-black text-8xl md:text-9xl gradient-text mb-6">404</div>
        <h1 className="font-sora font-bold text-2xl md:text-3xl text-white mb-4">
          {tr.notFound.title}
        </h1>
        <p className="text-gray-400 font-inter max-w-md mx-auto mb-10">
          {tr.notFound.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" data-testid="not-found-home" className="btn-primary">
            <Home size={18} /> {tr.notFound.cta}
          </Link>
          <Link to="/contact" data-testid="not-found-contact" className="btn-secondary">
            {tr.nav.contact} <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </main>
  );
}
